module.exports = __webpack_public_path__ + "img/award02_04.2d726320.png";